<template>
  <div class="fd-body">
    <div class="fd-b-airport d-flex justify-space-between align-start">
      <div>
        {{ legSelected[flight][0].origin.AirportName }} ({{ legSelected[flight][0].origin.AirportCode }})
        <i class="fas fa-plane"></i>
        {{ legSelected[flight][legSelected[flight].length - 1].destination.AirportName }} ({{ legSelected[flight][legSelected[flight].length - 1].destination.AirportCode }})
      </div>
      <a class="change-flight" @click="backLegSelect('leg1')">Change flight</a>
    </div>
    <div class="fd-cabin-class d-flex">
      <span>Cabin Class:</span>
      <span>{{ cabinLabel(legSelected.cabin) }}</span>
    </div>
    <div class="fd-b-airline d-flex align-start">
      <img :src="legSelected[flight][0].logo" />
      <div>
        <span>{{ legSelected.flightName }}</span>
        <span>{{ dateFormat(legSelected[flight][0].origin.DateTime) }}</span>
        <div class="fd-b-time">
          {{ timeFormat(legSelected[flight][0].origin.DateTime) }}
          -
          {{ timeFormat(legSelected[flight][legSelected[flight].length - 1].destination.DateTime) }}
          ({{ timeDiff(legSelected[flight][0].origin.DateTime, legSelected[flight][legSelected[flight].length - 1].destination.DateTime) }}, {{ countStop(legSelected[flight]) }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'flight-details',
  props: ['legSelected', 'leg'],
  computed: {
    settings () { return this.booking.settings },
    flight () {
      if (this.settings.customFlight && this.leg === 'leg2') return 'flight'
      return this.leg === 'leg1' ? 'flight' : 'returnFlight'
    },
    booking () { return this.$store.state.booking }
  },
  methods: {
    backLegSelect (leg) {
      let tmp = {}
      tmp[leg] = {}
      if (leg === 'leg1') tmp.leg2 = {}
      this.$store.commit('booking/setSelectedData', tmp)
      this.$store.commit('booking/setOthersData', {
        activeLeg: leg,
        servicesPage: 10
      })
      this.back()
    },
    back () {
      this.$store.commit('booking/setOthersData', {fetch: this.booking.cabinList})
      this.$router.push('d2dservice')
    },
    dateFormat (x, isFormated = false, eta = null) {
      if (!x) return ''
      let format = isFormated ? 'MM/DD/YYYY hh:mmA' : 'YYYY-MM-DD HH:mm'
      let date = moment(x, format)
      if (eta) date.add(eta, 'minutes')
      return date.format('ddd, MMM DD')
    },
    timeFormat (x, isFormated = false, eta = null) {
      if (!x) return ''
      let format = isFormated ? 'MM/DD/YYYY hh:mmA' : 'YYYY-MM-DD HH:mm'
      let date = moment(x, format)
      if (eta) date.add(eta, 'minutes')
      return date.format('h:mma')
    },
    timeDiff (x, y) {
      if (!x || !y) return ''
      x = moment(x, 'YYYY-MM-DD HH:mm')
      y = moment(y, 'YYYY-MM-DD HH:mm')
      let duration = moment.duration(y.diff(x))
      let days = duration._data.days ? `${duration._data.days}d ` : ''
      return `${days}${duration._data.hours}h ${duration._data.minutes}m`
    },
    countStop (data) {
      if (data.length === 1) return 'Direct Flight'
      return `${data.length - 1} Stop${data.length > 2 ? 's' : ''}`
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    }
  }
}
</script>

<style lang="scss" scoped>
.fd-body{
  .fd-b-airport{
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;

    i{
      margin: 0 15px;
      color: #717b87;
    }
  }
  .change-flight{
    color: #449ae7 !important;
    font-size: 13px;
    letter-spacing: .7px;
    font-weight: 500;
  }
  .fd-cabin-class{
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
    letter-spacing: .6px;
    gap: 10px;
  }
  .fd-b-airline{
    margin-bottom: 5px;
    font-size: 13px;
    color: #5E6E7F;
    gap: 15px;
    letter-spacing: .5px;

    img{
      width: 40px;
    }
    span{
      text-transform: capitalize;
    }
  }
  .fd-b-time{
    letter-spacing: .5px;
    font-size: 13px;
    color: #5E6E7F;
    margin-top: 7px;
  }
}
</style>


// WEBPACK FOOTER //
// FlightDetailsBox.vue?2352936b